import React from "react"
import { useSetting } from "app/forms/data/form-data"
import { OldButton } from "@kit/design/old-button"
import cx from "classnames"

export const PoweredByElement = ({ className, editing, onClick }) => {
  const handleClick = event => {
    event.preventDefault()
    onClick(event)
  }

  const [setting] = useSetting("PoweredBy")

  if (editing) {
    return (
      <OldButton
        type="button"
        className={cx(className, "outline-none focus:outline-none")}
        data-element="powered-by"
        data-active={setting.show}
        onClick={handleClick}
      >
        Powered By Kit
      </OldButton>
    )
  }

  if (setting.show) {
    return (
      <a
        href={setting.url}
        className={className}
        data-element="powered-by"
        target="_blank"
        rel="noopener noreferrer"
      >
        Powered By Kit
      </a>
    )
  }

  return null
}
